import React, { useState } from 'react';
import { CardBody } from 'reactstrap';
import DefaultModal from 'components/Modal/DefaultModal';
import ProductDetailsTable from '../ProductDetailsTable';

const ProductDetailsModal = ({
  isModalOpen,
  onModalToggle,
  productId,
  ...props
}) => {
  const [loading, setLoading] = useState(true);
  return (
    <>
      <DefaultModal
        show={isModalOpen}
        onModalToggle={onModalToggle}
        title="Detalhes do produto"
        showCloseButton={false}
        modalContainerClasses="modal-xl"
        {...props}
      >
        <CardBody>
          <ProductDetailsTable
            productId={productId}
            loadingTable={loading}
            onTableLoaded={setLoading}
          />
        </CardBody>
      </DefaultModal>
    </>
  );
};

export default ProductDetailsModal;
